<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAdd_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M18.429 2H5.571A3.57 3.57 0 0 0 2 5.571v12.857A3.57 3.57 0 0 0 5.571 22h12.857A3.57 3.57 0 0 0 22 18.429V5.571A3.57 3.57 0 0 0 18.429 2M17 13h-4v4a1 1 0 0 1-2 0v-4H7a1 1 0 0 1 0-2h4V7a1 1 0 0 1 2 0v4h4a1 1 0 0 1 0 2"
    />
</svg>
